import React, { useEffect, useState } from 'react';
import { Spin, Alert } from 'antd';
import { useCheckPaymentState } from '../../api/checkPaymentStateQuery';
import { useActions, useModalContentProps } from '../../model/state';
import { getUpdatedRequest } from '../../api/getUpdatedRequest';
import InvoiceFormData from '../InvoiceFormData/InvoiceFormData';
import { createSum } from '../../lib/sumUtils';
import { useCurrentPaymentTypes } from '../../api/currentPaymentTypesQuery';
import ChangePaymentTypes from '../ChangePaymentTypes/ChangePaymentTypes';
import PaymentStateField from '../PaymentStateField/PaymentStateField';
import { fieldNames } from '../../config/form';

const ChangesNotAllowed = ({ requestId }) => {
  const { onSuccessRef } = useActions();

  useEffect(() => {
    if (typeof onSuccessRef.current === 'function' && requestId) {
      getUpdatedRequest(requestId).then((data) => {
        if (data) {
          onSuccessRef.current(data);
        }
      });
    }
  }, []);

  return (
    <Alert
      message="Изменения невозможны, потому что оплата переведена в статус «Ожидание оплаты» или «Оплачено»"
      type="info"
      showIcon
    />
  );
};

const typesPlaceholder = { ids: [], typeNames: [] };
const emptyArr = [];

const ChangesAllowed = ({
  className,
  paymentState,
  sum,
  requestId,
  clientPaymentType,
  form,
}) => {
  const [hidePaymentState, setHidePaymentState] = useState(false);

  const { data, isFetching } = useCurrentPaymentTypes(
    { requestId },
    { enabled: Boolean(requestId), notifyOnChangeProps: ['data', 'isFetching'] }
  );

  const setPaymentStateHidden = () => setHidePaymentState(true);

  const types = clientPaymentType
    ? [clientPaymentType]
    : data?.paymentTypes || emptyArr;

  const { ids: currentPaymentTypes, typeNames } =
    types.reduce(
      (result, item) => {
        result.ids.push(item.id);
        result.typeNames.push(item.name);
        return result;
      },
      { ids: [], typeNames: [] }
    ) || typesPlaceholder;

  return (
    <Spin spinning={Boolean(isFetching)}>
      <div className={className}>
        {currentPaymentTypes.length !== 1 && (
          <Alert
            message="Чтобы изменить статус оплаты, выберите один способ оплаты"
            type="info"
            showIcon
          />
        )}

        <InvoiceFormData
          stateName={paymentState?.name}
          sum={sum}
          typeNames={typeNames.join(', ')}
        />

        <ChangePaymentTypes
          requestId={requestId}
          currentPaymentTypes={currentPaymentTypes}
          changeFail={setPaymentStateHidden}
          changeSuccess={() =>
            form.setFieldsValue({ [fieldNames.paymentState]: undefined })
          }
        />

        {Boolean(currentPaymentTypes.length === 1 && !hidePaymentState) && (
          <PaymentStateField
            form={form}
            paymentTypeId={currentPaymentTypes[0]}
            currentPaymentStateId={paymentState?.id}
          />
        )}
      </div>
    </Spin>
  );
};

const TypesAndStateForm = ({ form, className }) => {
  const { entity } = useModalContentProps();
  const { id, invoice } = entity || {};
  const { paymentState, sum, paymentType: clientPaymentType } = invoice || {};

  const { data, isFetching } = useCheckPaymentState(id, {
    enabled: Boolean(id),
    notifyOnChangeProps: ['data', 'isFetching'],
  });

  const changesNotAllowed = data && !data.success;

  return (
    <Spin spinning={isFetching}>
      {changesNotAllowed ? (
        <ChangesNotAllowed requestId={id} />
      ) : (
        <ChangesAllowed
          className={className}
          paymentState={paymentState}
          sum={createSum({ sum })}
          requestId={id}
          clientPaymentType={clientPaymentType}
          form={form}
        />
      )}
    </Spin>
  );
};

export default TypesAndStateForm;
